// InlineAnomalyChip — küçük satır içi ⚠ rozet (CR2-10).
// Sinyal listesi (push satırı) ve Anne audit tablosu (fon satırı) gibi
// noktalarda "bu fonda açık anomali var" bağlamı verir.
//
// Tıklama → AnomalyPopover (bottom-sheet) — alert() placeholder kaldırıldı.
// stopPropagation ile çevreleyici link/satır tetiklenmez.

import { useState } from "react";
import type { Anomaly } from "../types/api";
import AnomalyPopover from "./AnomalyPopover";

interface Props {
  fund: string;
  anomalies: Anomaly[];
  /** İkon boyutu — varsayılan 9 (sinyal listesi). Audit tablosunda 8. */
  size?: 8 | 9;
  /** Override: kendi popover'ını açmak yerine üst component'e devret. */
  onClick?: (fund: string, anomalies: Anomaly[]) => void;
}

export default function InlineAnomalyChip({
  fund,
  anomalies,
  size = 9,
  onClick,
}: Props) {
  const [open, setOpen] = useState(false);

  if (anomalies.length === 0) return null;

  function handleClick(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    if (onClick) onClick(fund, anomalies);
    else setOpen(true);
  }

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        title={`Bu fonda ${anomalies.length} açık veri uyarısı var`}
        className="inline-warn-chip"
        aria-label={`${fund} için ${anomalies.length} açık veri uyarısı`}
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01" />
        </svg>
        <span>{anomalies.length}</span>
      </button>
      {open && (
        <AnomalyPopover
          fund={fund}
          anomalies={anomalies}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
